//#region IMPORT
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog } from '../../../Components/MUIs';
import { Box, Stack, Typography } from '@mui/material';
import { Group as GroupIcon } from '@mui/icons-material';
import Lottie from 'lottie-react';
import AiAnimation from '../../../Assets/animations/Loading.json';
import DocumentViewer from '../../../Components/Ui/DocumentViewer';
import { CommonActions } from '../../../Reducer/CommonReducer';
//#endregion

function M_TBM_BASIC_04(props) {
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const ext = props.getExtensionFromUrl(props.pdfFile);

  const renderViewer = () => {
    if (!props.pdfFile) {
      return (
        <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
          작업계획서가 없습니다.
        </Typography>
      );
    }

    switch (ext) {
      case 'pdf':
      case 'hwp':
        return (
          <DocumentViewer
            renderPreview={props.renderPreview}
            loading={props.loading}
            onDocumentLoadSuccess={props.onDocumentLoadSuccess}
            pageNumber={props.pageNumber}
            pageWidth={props.pageWidth}
            pageViewHeight={props.pageViewHeight}
            setPageViewHeight={props.setPageViewHeight}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        );

      default:
        return (
          <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
            미리보기를 지원하지 않는 파일 형식입니다.
          </Typography>
        );
    }
  };

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          작업계획서
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          파일 자료를 통해 작업계획서를 확인해주세요.
        </Typography>
      </Stack>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          overflow: 'hidden', // 스크롤 방지
        }}
      >
        {renderViewer()}

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ p: 2, width: '100%' }}
        >
          <Button
            sx={{ width: '100%', height: '36px', borderRadius: '18px' }}
            name="이전"
            onClick={props.goToPrevPage}
          />
          <Typography
            sx={{
              fontWeight: 'bold',
              mx: 6,
              whiteSpace: 'nowrap',
            }}
          >
            {props.pageNumber} / {props.numPages}
          </Typography>
          <Button
            sx={{ width: '100%', height: '36px', borderRadius: '18px' }}
            name={
              props.pageNumber === props.numPages || !props.pdfFile
                ? '완료'
                : '다음'
            }
            onClick={() => {
              if (props.pageNumber === props.numPages || !props.pdfFile) {
                // props.ActiveButton({
                //   type: 'check2',
                //   id: props.userInfo.userid,
                //   content: true,
                // });
                dispatch(CommonActions.setActiveStep(activeStep + 1));
              } else {
                props.goToNextPage();
              }
            }}
          />
        </Stack>
      </Box>
      {props.modalToggle2 && (
        <Dialog
          open={props.modalToggle2}
          sx={{ height: '90vh' }}
          titleSx={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#D9D9D9',
            pt: 3,
            pb: 1.5,
          }}
          contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)', // 좌우 마진 고려한 전체 너비
              maxWidth: '100%', // 혹시 모를 제한 제거
            },
          }}
          fullWidth={true}
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => {}}
          maxWidth={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Lottie
                animationData={AiAnimation}
                loop
                autoplay
                style={{
                  display: 'flex',
                  width: '50px',
                  height: '30px',
                  overflow: 'hidden',
                  transform: 'scale(4)',
                }}
              />
              <Box>
                <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                  교육이 종료되었습니다.
                </Typography>
                <Typography>TBM완료 후 AI콜을 진행해주세요.</Typography>
              </Box>
              <Box
                sx={{
                  pt: 2,
                  gap: 0.5,
                  display: 'flex',
                  justifyContent: 'start',
                  alignContent: 'center',
                }}
              >
                <GroupIcon />
                <Typography>
                  {/* 현재 100명 중{" "} */}
                  <Typography
                    component="span"
                    fontWeight="bold"
                    sx={{ color: '#00789E' }}
                  >
                    {
                      props.check.filter((item) => item.type === 'check2')
                        .length
                    }
                    명
                  </Typography>{' '}
                  참가 완료
                </Typography>
              </Box>
            </Box>
          }
        />
      )}
    </>
  );
}

export default M_TBM_BASIC_04;
